import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;

function setupBillItems() {
    $('#add-bill-item').on('click', function(e) {
        e.preventDefault();
        var uniqueId = new Date().getTime();
        var templateHtml = $('#bill-item-template').html();
        var newRowHtml = templateHtml.replace(/NEW_RECORD/g, uniqueId);

        var $newRow = $(newRowHtml);

        $newRow.find('.select2-container').remove();
        $newRow.find('select')
            .removeClass('select2-hidden-accessible')
            .removeAttr('data-select2-id aria-hidden tabindex id');
        $newRow.find('option').removeAttr('data-select2-id');

        $('#bill-items-container').append($newRow);

        $newRow.find('select').select2({
            width: '100%',
            theme: 'classic' // Quítalo si notas que el estilo no cuadra con el original
        });
    });
    // ELIMINAR PARTIDA
    $('#bill-items-container').on('click', '.remove-bill-item', function(e) {
        e.preventDefault();

        // Buscamos la fila entera
        var row = $(this).closest('.bill-item-row');

        // Le decimos a Rails que lo marque para destruir
        row.find('.destroy-flag').val('1');

        // Ocultamos la fila visualmente
        row.hide();

    });
}

// 1. Función modular: Recibe un "scope" (puede ser toda la tabla o solo un renglón nuevo)
function initBatteryModelSearch($scope) {
    $scope.find('.battery-ajax-search').each(function() {
        var $select = $(this);
        if ($select.hasClass('select2-hidden-accessible')) {
            $select.select2('destroy');
        }
        var searchUrl = $select.data('url');

        $select.select2({
            width: '100%',
            theme: 'classic',
            placeholder: 'Busca por BCI, Marca o Grupo...',
            allowClear: true,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 300, // Retraso nativo de Select2 (reemplaza tu setTimeout)
                data: function (params) {
                    return { q: params.term };
                },
                processResults: function (data) {
                    // Tu controlador ya devuelve { results: [...] }
                    return data; 
                },
                cache: true
            }
        });
    });
}

// 2. Configuración de los Renglones Dinámicos
function setupBillInventories() {
    // A. INICIALIZACIÓN AL CARGAR LA PÁGINA (Edición o Rebote de errores)
    // Inicializamos el AJAX de las baterías que ya existen
    initBatteryModelSearch($('#bill-inventories-container'));
    
    // Inicializamos el Select2 estándar (Ubicaciones) de los renglones que ya existen
    $('#bill-inventories-container').find('select:not(.battery-ajax-search)').each(function() {
        var $select = $(this);
        if (!$select.hasClass('select2-hidden-accessible')) {
            $select.select2({ width: '100%', theme: 'classic' });
        }
    });

    // B. EVENTO PARA AGREGAR NUEVO RENGLÓN
    $('#add-bill-inventory').off('click').on('click', function(e) {
        e.preventDefault();
        var uniqueId = new Date().getTime();
        var templateHtml = $('#bill-inventory-template').html();
        var newRowHtml = templateHtml.replace(/NEW_RECORD/g, uniqueId);
        var $newRow = $(newRowHtml);

        // Limpieza de Select2 clonado del template
        $newRow.find('.select2-container').remove();
        $newRow.find('select')
            .removeClass('select2-hidden-accessible')
            .removeAttr('data-select2-id aria-hidden tabindex id');
        $newRow.find('option').removeAttr('data-select2-id');

        $('#bill-inventories-container').append($newRow);

        // ¡EL DETALLE CLAVE! Inicializar Select2 estático EXCLUYENDO el de AJAX
        $newRow.find('select:not(.battery-ajax-search)').select2({
            width: '100%',
            theme: 'classic' 
        });

        // Inicializar el buscador AJAX exclusivamente en este nuevo renglón
        initBatteryModelSearch($newRow);
    });

    // C. EVENTO PARA ELIMINAR RENGLÓN
    $('#bill-inventories-container').off('click', '.remove-bill-inventory').on('click', '.remove-bill-inventory', function(e) {
        e.preventDefault();
        var row = $(this).closest('.bill-inventory-row');
        row.find('.destroy-flag').val('1');
        row.hide();
    });
}

function setupBillsForm() {
    const form = document.getElementById("bills-form");
    if (form) {
        if (typeof setupBillItems === "function") setupBillItems();
        setupBillInventories();
    }
}

function destroyBillsForm() {
    const form = document.getElementById("bills-form");
    if (form) {
        $('#add-bill-item').off('click');
        $('#bill-items-container').off('click');
        $('#add-bill-inventory').off('click');
        $('#bill-inventories-container').off('click');
    }
}
// document.addEventListener("turbolinks:load", setupBillsForm);
$(document)
    .off('turbolinks:load.billsForm')
    .on('turbolinks:load.billsForm', function() {
        setupBillsForm();
    });

// document.addEventListener('turbolinks:before-cache', destroyBillsForm);
window.addEventListener('beforeunload', (event) => {
    destroyBillsForm();
});


